<template lang="html">

  <div class="productos">

    <section class="vh intro">
      <div class="bkg-pieza waypoints-instant -responsiveIntro" data="fadeInUp">
        <a href="#" v-scroll-to="'.-sistemas'" class="scrolldown"></a>
        <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft -introText">
          <div class="container-text">
            <h2 class="title title-52" v-html="$t('productos.titulo')"></h2>
            <p v-html="$t('productos.entradilla')" ></p>
          </div>
        </div>
      </div>
    </section>
    <div class="container_productos">
      <section class="product-box -sistemas row-end">
        <img src="/static/img/productos/extensor-de-autonomia.png" class="img-producto -extensor-autonomia" alt="Extensor de autonomía">
        <div class="container">
          <div class="contenedor-texto">
            <h2 class="title title-36" v-html="$t('proyectos_IDI.modulo_extensor.title')"></h2>
            <p v-html="$t('proyectos_IDI.modulo_extensor.description')"></p>
            <div class="flex wrap justify-center logos-sellos">
              <img src="/static/img/productos/logo-cdti.png">
              <img src="/static/img/productos/logo-next-generation.png">
              <img src="/static/img/productos/logo-plan-recuperacion.png">
            </div>
          </div>
        </div>
      </section>

      <section class="product-box -sistemas row-end">
        <img src="/static/img/productos/sistema-de-potencia.png" class="img-producto -sistema-potencia"
          alt="Sistema de potencia">
        <div class="container">
          <div class="contenedor-texto">
            <h2 class="title title-36" v-html="$t('productos.sistema_ponencia.title')"></h2>
            <p v-html="$t('productos.sistema_ponencia.description')"></p>
            <router-link :to="$t('productos.sistema_ponencia.descargas.ponencia1200w.descarga')" target="_blank"
              class="descarga" v-html="$t('productos.sistema_ponencia.descargas.ponencia1200w.nombre')"></router-link>
            <span class="descarga" v-html="$t('productos.sistema_ponencia.descargas.ponencia7500k.nombre')"></span>
            <!-- <router-link :to="$t('productos.sistema_ponencia.descargas.ponencia500AC.descarga')"target="_blank"  class="descarga" v-html="$t('productos.sistema_ponencia.descargas.ponencia500AC.nombre')"></router-link>
            -->
          </div>
        </div>
      </section>



      <section class="product-box -pilas row-end">
        <img src="/static/img/productos/pila.png" class="img-producto -pila" alt="Sistema de potencia">
        <div class="container">
          <div class="contenedor-texto">
            <h2 class="title title-36" v-html="$t('productos.sistema_pilas.title')"></h2>
            <p v-html="$t('productos.sistema_pilas.description_1')"></p>
            <p v-html="$t('productos.sistema_pilas.description_2')"></p>
            <router-link :to="$t('productos.sistema_pilas.descarga')"  target="_blank" class="descarga" v-html="$t('productos.sistema_pilas.nombre')"></router-link>
          </div>
        </div>
      </section>
    </div>
    <section class="product-box -componentes row-end">
      <div class="container">
        <div class="contenedor-texto">
          <h2 class="title title-36" v-html="$t('productos.componentes_pilas.title')"></h2>
          <p v-html="$t('productos.componentes_pilas.description')"></p>
        </div>
      </div>
      <button class="show-section" :show="componentes_pilas" @click="componentes_pilas = !componentes_pilas"></button>

      <div class="contenedor-descargas row-start" :hide="!componentes_pilas">

        <article class="descarga-el row-start">

          <img src="/static/img/productos/placas-bipolares.jpg" alt="">

          <router-link :to="$t('productos.componentes_pilas.placas.descarga')" target="_blank" class="descarga"
            v-html="$t('productos.componentes_pilas.placas.nombre')"></router-link>

        </article>

        <article class="descarga-el row-start">

          <img src="/static/img/productos/colectores-corriente.jpg" alt="">

          <router-link :to="$t('productos.componentes_pilas.colector.descarga')" target="_blank" class="descarga"
            v-html="$t('productos.componentes_pilas.colector.nombre')"></router-link>

        </article>

        <article class="descarga-el row-start">

          <img src="/static/img/productos/mea.jpg" alt="">

          <router-link :to="$t('productos.componentes_pilas.MEA.descarga')" target="_blank" class="descarga"
            v-html="$t('productos.componentes_pilas.MEA.nombre')"></router-link>

        </article>

        <article class="descarga-el row-start">

          <img src="/static/img/productos/placas-compresion.jpg" alt="">

          <router-link :to="$t('productos.componentes_pilas.placas_comprension.descarga')" target="_blank"
            class="descarga" v-html="$t('productos.componentes_pilas.placas_comprension.nombre')"></router-link>

        </article>

        <article class="descarga-el row-start">

          <img src="/static/img/productos/juntas.jpg" alt="">

          <router-link :to="$t('productos.componentes_pilas.juntas.descarga')" target="_blank" class="descarga"
            v-html="$t('productos.componentes_pilas.juntas.nombre')"></router-link>

        </article>

      </div>

    </section>
    <section class="state-servicio product-box -componentes row-end">
      <div class="image waypoints" data="fadeInLeft"></div>
      <div class="content waypoints" data="fadeInRight">
        <h2 class="title title-36" v-html="$t('productos.estacion_servicio.titulo')"></h2>
        <ul v-html="$t('productos.estacion_servicio.carasteristicas')"></ul>
      </div>
    </section>
    


    <otras-secciones :data="['tecnologia', 'proyectos']"></otras-secciones>

  </div>


</template>

<script lang="js">

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

  export default  {
    name: 'productos',
    props: [],
    mounted() {

    },
    data() {
      return {
        componentes_pilas : false
      }
    },
    methods: {

    },
    components: {
      'otras-secciones' : Otras_Secciones
    }
  }
</script>

<style scoped  >
.productos .intro {
  position: relative;
  height: auto;
  min-height: 100vh;
  background: url(/static/img/bkg/bkg-productos.jpg) center/cover no-repeat;
}

.productos .intro .col-50 {
  background: rgba(5, 66, 121, 0.9);
  height: 100vh;
}

.productos .intro p {
  max-width: 350px;
}

.product-box {
  padding: 50px;
  position: relative;
}

.product-box .img-producto {
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 2;
}

.product-box .container {
  padding: 100px 50px;
  max-width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  padding-left: 500px;
}

.product-box.-sistemas {
  padding-bottom: 25px;
}

.product-box.-sistemas .container {
  background: url(/static/img/bkg-metal.jpg) center/cover no-repeat;
}

.product-box.-pilas {
  padding-top: 25px;
  padding-bottom: 25px;
}

.product-box.-pilas .container {
  background: #e6ecf1;
}

.product-box.-componentes {
  padding-top: 25px;
}

.product-box.-componentes .container {
  background: #cdd9e4;
  padding: 75px;
}

.product-box .contenedor-texto {
  max-width: 718px;
}

.product-box.-componentes .contenedor-texto {
  max-width: 900px;
}

.descarga-el {
  width: 50%;
  margin-bottom: 30px;
}
.descarga-el img {
  max-width: 170px;
}

.descarga-el .descarga {
  max-width: calc(100% - 260px);
  padding-left: 50px;
  display: inline-block;
  margin-top: 0;
}

.descarga:first-of-type {
  max-width: 430px;
}

.descarga {
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
  -ms-align-items: center;
  align-items: center;
  text-transform: uppercase;
  color: #02203c;
  font-family: "HalisGR-Book";
  font-weight: 800;
  margin-bottom: 20px;
}

.descarga::after {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url(/static/img/download-arrow.svg) center/auto 28px no-repeat;
  transform: rotate(90deg);
  content: "";
  margin-left: 10px;
}
span.descarga {
  margin-top: 10px;
}
span.descarga::after {
  display: none;
}
.descarga-el .descarga::after {
  transform: translateY(10px) rotate(90deg);
}

.descarga:last-of-type {
  margin-bottom: 0;
}

.show-section {
  height: 100px;
  font-size: 40px;
  font-weight: 300;
  color: #fff;
  background: #02203c url(/static/img/more.svg) center/ auto 70px no-repeat;
  border: none;
  width: 100%;
  outline: none;
  cursor: pointer;
  transition: 0.5s;
}

.show-section[show="true"] {
  background: #02203c url(/static/img/less.svg) center/ auto 70px no-repeat;
}

.contenedor-descargas {
  padding: 75px;
  width: 100%;
  background: #e6ecf1;
  -webkit-transition: height 0.3s linear, padding-top 0.3s linear,
    padding-bottom 0.3s linear, border-top-width 0.3s linear,
    border-top-width 0.3s linear;
  transition: height 0.3s linear, padding-top 0.3s linear,
    padding-bottom 0.3s linear, border-top-width 0.3s linear,
    border-top-width 0.3s linear;
}

.contenedor-descargas[hide="true"] {
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
  height: 0;
  border-width: 0 1px;
}
.container_productos {
  margin: 0 auto;
  max-width: 1600px;
  margin-top: 30px;
}
.img-producto.-sistema-potencia {
  max-width: 400px;
}
.img-producto.-pila {
  max-width: 420px;
}
.img-producto.-extensor-autonomia {
  max-width: 520px;
  left: -40px;
  top: 60px;
}
.state-servicio {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
}
.state-servicio .image {
  width: 50%;
  height: 100%;
  display: inline-block;
  background: url(/static/img/bkg/bg-estacion-servicio.jpg) center/cover
    no-repeat;
  min-height: 500px;
}
.state-servicio .content {
  width: 50%;
  background: url(/static/img/bkg-metal.jpg) center/cover no-repeat;
  height: 100%;
  padding: 40px 55px;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
.state-servicio .content ul {
  padding-left: 20px;
}
.state-servicio .content ul li {
  list-style: disc;
  margin-bottom: 10px;
}
  .logos-sellos {
    margin-top: 15px;
  }

  .logos-sellos img {
    max-width: 25%;
    height: auto;
    object-fit: contain;
  }

@media screen and (max-width: 1450px) {
  .descarga-el img {
    max-width: 115px;
  }
  .descarga:first-of-type {
    max-width: 370px;
  }
}
@media screen and (max-width: 1350px) {
  .descarga-el img {
    max-width: 120px;
  }
}

@media screen and (max-width: 1250px) {
  .product-box .container {
    padding-left: 300px;
  }

  .product-box .img-producto {
    max-width: 250px;
  }

    .product-box .img-producto.-extensor-autonomia {
    max-width: 350px;
  }

  .contenedor-descargas {
    padding: 50px;
  }

  .descarga-el {
    width: 100%;
  }

  .descarga-el .descarga {
    max-width: calc(100% - 150px);
  }
}
@media screen and (max-width: 1154px) {
  .state-servicio .content {
    padding: 40px;
  }
}
@media screen and (max-width: 1090px) {
  .state-servicio .image,
  .state-servicio .content {
    min-height: 580px;
  }
}
@media screen and (max-width: 900px) {
  .state-servicio .image,
  .state-servicio .content {
    width: 100%;
  }
  .product-box.-componentes {
    flex-direction: column-reverse;
  }
  .state-servicio .content {
    min-height: auto;
    padding: 75px;
  }
}
@media screen and (max-width: 850px) {
  .product-box {
    padding: 20px;
  }

  .product-box .container {
    padding: 30px 30px 30px 30px;
  }

  .img-producto {
    display: none;
  }

  .descarga {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .descarga-el {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    margin-bottom: 60px;
  }

  .descarga-el .descarga {
    max-width: 100%;
    padding: 0;
    text-align: center;
    margin-top: 15px;
    position: relative;
  }

  .descarga-el .descarga::after {
    position: absolute;
    left: 50%;
    bottom: -30px;
    transform: translateX(-50%) rotate(90deg);
    margin-left: 0;
  }

  .contenedor-descargas {
    padding: 50px 20px;
  }

  .contenedor-descargas .descarga-el:last-of-type {
    margin-bottom: 0;
  }
}

@media screen and (max-width: 600px) {
  .product-box.-componentes .container,
  .state-servicio .content {
    padding: 50px 20px;
  }
  .state-servicio .image {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/productos.vue